import { useEffect, useRef, useState, type RefObject } from 'react';

/** Dispara `true` uma vez quando o elemento entra no viewport (IntersectionObserver). */
export function useInViewOnce<T extends Element = HTMLDivElement>(
  options?: IntersectionObserverInit
): { ref: RefObject<T>; inView: boolean } {
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (inView) return;
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setInView(true);
          obs.disconnect();
        }
      },
      { root: null, rootMargin: '200px 0px', threshold: 0.01, ...options }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [inView, options]);

  return { ref: ref as RefObject<T>, inView };
}
